import React from 'react';
import Button from '../../../components/ui/Button';


const CategoryFilter = ({ activeCategory, onCategoryChange }) => {
  const categories = [
    { id: 'all', name: 'All Items', icon: 'Grid3X3' },
    { id: 'shoes', name: 'Shoes', icon: 'Footprints' },
    { id: 'clothes', name: 'Clothes', icon: 'Shirt' },
    { id: 'bags', name: 'Bags', icon: 'ShoppingBag' }
  ];

  return (
    <div className="flex flex-wrap justify-center gap-2 mb-8">
      {categories?.map((category) => (
        <Button
          key={category?.id}
          variant={activeCategory === category?.id ? "default" : "outline"}
          onClick={() => onCategoryChange(category?.id)}
          iconName={category?.icon}
          iconPosition="left"
          className="min-w-[120px]"
        >
          {category?.name}
        </Button>
      ))}
    </div>
  );
};

export default CategoryFilter;